import script from "./componentPreview.vue?vue&type=script&lang=js"
export * from "./componentPreview.vue?vue&type=script&lang=js"

import "./componentPreview.vue?vue&type=style&index=0&id=2a75c136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a75c136"]])

export default __exports__